 <template>
    <div class="low-line-chart">
        <div ref="lineChart" :style="{width:width,height:height}"></div>
        <div class="no-img" v-if="!dataList || dataList.length == 0">
            <img src="../img/nodata.png" alt="" />
            <span>暂无图片</span>
        </div>
    </div>
</template>

<script>
import { unwarp } from "@/utils/tools.js";
export default {
    props: {
        width: {
            default: "100%",
        },
        height: {
            default: "300px",
        },
        title: {
            type: String,
            default: "",
        },
        dataList: {
            // default: [],
        }
    },
    data () {
        return {
            chart: null,
            option: {
                grid: {
                    top: '15%',
                    left: '3%',
                    right: '3%',
                    bottom: '8%',
                    containLabel: true
                },
                color: ['#8cc6d9', '#5470c6'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'line',
                        snap: true,
                        lineStyle: {
                            color: {
                                type: 'linear',
                                colorStops: [
                                    {
                                        offset: 0,
                                        color: '#3E86DB' // 0% 处的颜色
                                    },
                                    {
                                        offset: 1,
                                        color: '#B8FFFB' // 100% 处的颜色
                                    },
                                ],
                                global: false // 缺省为 false
                            },
                            width: 2
                        }
                    },
                    backgroundColor: "#000000",
                    formatter (params) {
                        let str = "";
                        params.forEach(item => {
                            let value = item.value;
                            if (item.data && item.data.tooltip) {
                                value = item.data.tooltip;
                            }
                            str += `
                	        		<dl class="tooltip" style="font-size:14px; color: #D7D7D7">
                						<dt style="font-size:14px;">${item.axisValue}</dt>
                						<dd>${item.seriesName}：${value}</dd>
                	        		</dl>	        		
                	        	`
                        })
                        return str
                    }
                },

                legend: {
                    selectedMode: false,//取消图例上的点击事件
                    show: true,
                    data: [],
                    right: '2.7%',
                    top: '0%',
                    itemHeight: 5,
                    itemGap: 28,
                    icon: "roundRect",
                    textStyle: {
                        color: '#C8DDE1',
                        fontSize: 16,
                    },
                },

                xAxis: {
                    type: 'category',
                    // data: ['00:00', '01:15', '02:30', '03:45', '05:00', '06:15', '07:30', '08:45', '10:00', '11:15', '12:30', '13:45', '15:00', '16:15', '17:30', '18:45', '20:00', '21:15', '22:30', '23:45'],
                    // data: date,
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: 'rgba(62, 134, 219, 1)',
                            width: 1
                        }
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: 'rgba(62, 134, 219, 0.1)',
                            width: 1
                        }
                    },
                    boundaryGap: true,
                    axisLabel: {
                        textStyle: {
                            color: '#D7D7D7',
                            fontSize: 16,
                            margin: 15
                        }
                    },
                    axisTick: {
                        show: false
                    }
                },
                yAxis: {
                    // name: "单位：" + this.dataList.unit,
                    nameTextStyle: {
                        fontSize: 16,
                        color: '#D7D7D7',
                        padding: [0, 0, 0, 20]
                    },
                    type: 'value',
                    splitLine: {
                        show: true,
                        lineStyle: {
                            color: 'rgba(62, 134, 219, 0.2)',
                            width: 1
                        }
                    },
                    axisLine: {
                        show: true,
                        lineStyle: {
                            color: 'rgba(62, 134, 219, 0.2)',
                            width: 1
                        }
                    },
                    axisLabel: {
                        margin: 10,
                        textStyle: {
                            color: '#D7D7D7',
                            fontSize: 16
                        }
                    },
                    axisTick: {
                        show: false
                    }
                },
                series: [{
                    // name: this.dataList.deviceName,
                    // data: [300, 280, 250, 260, 270, 300, 550, 500, 400, 390, 380, 390, 400, 500, 600, 750, 800, 700, 600, 400],
                    // data: value,
                    type: 'line',
                    showSymbol: false,
                    symbolSize: 4
                }]
                // series
            }
        };
    },
    watch: {
        dataList: {
            deep: true,
            handler (data) {
                let that = this
                if (data && data.assembleData.length) {
                    let date = []
                    let value = []
                    for (let item of data.assembleData) {
                        date.push(item.dataTime)
                        value.push(item.avg_tdc)
                    }
                    this.$nextTick(function() {
                        that.drawChart(date, value);
                    })
                    
                }
            },
            immediate: true
        },
    },
    methods: {
        drawChart (label, data) {
            this.chart = echarts.init(this.$refs.lineChart);
            this.option.series[0].name = this.dataList.deviceName + "pm10";
            this.option.legend.data[0] = this.dataList.deviceName + "pm10";
            this.option.xAxis.data = label;
            this.option.yAxis.name = "单位：" + this.dataList.unit
            this.option.series[0].data = data;
            unwarp(this.chart).setOption(this.option);
            this.$nextTick(() => {
                this.chart.resize();
            });
        },
    },
    mounted () {
        // const label = ["第一季度", "第二季度", "第三季度", "第四季度"];
        // const data = [60, 80, 120, 50];
        // this.drawChart(label, data);
    },
};
</script>

<style lang="scss" scoped>
.low-line-chart {
    background: rgba($color: #000, $alpha: 0.11);
    box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.07);
    margin-bottom: 30px;
}

.low-line-chart-title {
    font-size: 18px;
    font-weight: 400;
    color: #e2effd;
    line-height: 18px;
    padding: 10px 0 23px 10px;
}
.no-data,
.no-img {
    display: flex;
    align-items: center;
    flex-direction: column;
    background: rgba($color: #000000, $alpha: 0.2);
    padding: 50px 0 10px 0;
    img {
        width: 200px;
    }
    span {
        color: #505f83;
        font-size: 16px;
        margin-top: 8px;
    }
}
.no-img {
    background: none;
}
</style>